import * as yup from 'yup';
import {
  INVALID_EMAIL_ADDRESS_MSG,
  INVALID_PHONE_NUMBER_MSG,
  SMS_OPT_IN_REQUIRED_MSG,
} from '../../validation';

const PHONE_REGEX = /^\(?([2-9][0-9]{2})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;

export const customerContactFormSchema = yup.object().shape({
  email: yup
    .string()
    .trim()
    .required(INVALID_EMAIL_ADDRESS_MSG)
    .email(INVALID_EMAIL_ADDRESS_MSG),
  phoneNumber: yup
    .string()
    .nullable()
    .transform(value => (value === '' ? null : value))
    .matches(PHONE_REGEX, INVALID_PHONE_NUMBER_MSG)
    .label('Phone number'),
  smsOptIn: yup.bool().when('phoneNumber', (phoneNumber, schema, { value }) => {
    if (phoneNumber && phoneNumber !== '') {
      return yup
        .bool()
        .oneOf([true], SMS_OPT_IN_REQUIRED_MSG)
        .required(SMS_OPT_IN_REQUIRED_MSG)
        .label('Send me SMS updates');
    } else if (!!value && phoneNumber === null) {
      return yup
        .bool()
        .oneOf([false], INVALID_PHONE_NUMBER_MSG)
        .required(INVALID_PHONE_NUMBER_MSG)
        .label('Send me SMS updates');
    } else {
      return yup.bool().label('Send me SMS updates');
    }
  }),
});
